import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { previewModeOn } from '../authenticator/authenticatorSlice';
import { fetchAuthorizationInfo } from '../authorizationInfo/api/fetchAuthorizationInfo';

import type { RootState } from '@/app/store';
import {
  REACT_APP_AUTH_INFO,
  REACT_APP_CUCON_API_DOMAIN,
  REACT_APP_ENVIRONMENT,
} from '@/config';
import { CUCON_API_PATH } from '@/constants';
import { amplifyMemoryStorage, setAmplifyConfig } from '@/lib/amplify';
import { getSubdomain } from '@/utils/getSubdomain';

export function Preview() {
  const { serviceProfile } = useSelector(
    (state: RootState) => state.serviceProfile
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const subdomain = serviceProfile.domain?.subdomain ?? getSubdomain();
    const protocol =
      REACT_APP_ENVIRONMENT === 'local' || REACT_APP_ENVIRONMENT === 'test'
        ? 'http://'
        : 'https://';
    const managementAppDomain = `${protocol}${subdomain}.${serviceProfile.domain.managementApp}`;
    const srcDomain = window.document.referrer;

    const setCognito = async (event: MessageEvent) => {
      const authorizationInfoApiUrl =
        serviceProfile?.cuconConfig?.authorizationInfoUrl ??
        REACT_APP_CUCON_API_DOMAIN + CUCON_API_PATH.authorizationInfo;
      const authInfo =
        serviceProfile?.cuconConfig?.authInfo ?? REACT_APP_AUTH_INFO;
      const tenantAlias = serviceProfile?.cuconConfig?.tenantAlias;

      if (event.origin !== managementAppDomain) {
        // 想定している管理画面のドメイン以外からは受け付けない
        return;
      }
      window.removeEventListener('message', setCognito);

      try {
        const res = await fetchAuthorizationInfo(
          tenantAlias,
          authorizationInfoApiUrl,
          authInfo
        );
        if (res.data?.authorizationInfo[0] !== undefined) {
          const cognitoToken = event.data as Record<string, string>;
          for (const [key, value] of Object.entries(cognitoToken)) {
            amplifyMemoryStorage.setItem(key, value);
          }
          setAmplifyConfig(res.data?.authorizationInfo[0], true);
          dispatch(previewModeOn());
        }
      } catch (error) {
        console.error('getAuthorizationInfo: ', error);
      }
      const mapType = searchParams.get('mapType');
      if (mapType !== null) {
        navigate(`/${mapType}`);
      } else {
        navigate('/');
      }
    };

    if (srcDomain === `${managementAppDomain}/`) {
      window.opener.postMessage(
        {
          action: 'Notification',
          message: 'ok',
        },
        srcDomain
      );
      window.addEventListener('message', setCognito);
    }
  }, [
    dispatch,
    navigate,
    searchParams,
    serviceProfile?.cuconConfig?.authInfo,
    serviceProfile?.cuconConfig?.authorizationInfoUrl,
    serviceProfile?.cuconConfig?.tenantAlias,
    serviceProfile.domain.managementApp,
    serviceProfile.domain?.subdomain,
  ]);

  return null;
}
